import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_ADDRESSES, SET_EMPLOYEE_ADDRESS, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_EMPLOYEE_ADDRESS_ISLOADING,
  DELETE_EMPLOYEE_ADDRESS,
  EDIT_EMPLOYEE_ADDRESS,
  GET_EMPLOYEE_ADDRESSES,
  GET_EMPLOYEE_ADDRESS,
  REGISTER_EMPLOYEE_ADDRESS,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeeAddress from '@/services/employee_address';
import { Module } from 'vuex';
import { EditEmployeeAddress, RegisterEmployeeAddress, GetEmployeeAddress } from '@/dtos/employee_address.dto';

const employeeAddress: Module<any, {}> = {
  state: {
    employeeAddress: {
      data: null,
      isLoading: false,
    },
    employeeAddresses: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeeAddress: (state: { employeeAddress: any }) => state.employeeAddress,
    employeeAddresses: (state: { employeeAddresses: any }) => state.employeeAddresses,
  },
  mutations: {
    [SET_EMPLOYEE_ADDRESS]: (
      state: { employeeAddress: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeAddress.data = payload.data) : null,
        (state.employeeAddress.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_ADDRESSES]: (
      state: { employeeAddresses: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeAddresses.data = payload.data) : null,
        (state.employeeAddresses.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EMPLOYEE_ADDRESS]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_ADDRESS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAddress.registerEmployeeAddress(
        payload as RegisterEmployeeAddress
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_ADDRESS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_ADDRESS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ADDRESS, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_ADDRESSES]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_ADDRESSES, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAddress.getEmployeeAddresses(
        payload as GetEmployeeAddress
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_ADDRESSES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_ADDRESSES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ADDRESSES, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_ADDRESS]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_ADDRESS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAddress.getEmployeeAddresses(
        payload as GetEmployeeAddress
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_ADDRESS, { data: result.data.data[0], isLoading: false });
          return result.data.data[0];
        }
        commit(SET_EMPLOYEE_ADDRESS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ADDRESS, { isLoading: false });
        return false;
      }
    },
    [EDIT_EMPLOYEE_ADDRESS]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_ADDRESS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAddress.editEmployeeAddress(
        payload as EditEmployeeAddress
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_ADDRESS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_ADDRESS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ADDRESS, { isLoading: false });
        return false;
      }
    },
    [DELETE_EMPLOYEE_ADDRESS]: async ({ commit }: any, payload: string) => {
      commit(SET_EMPLOYEE_ADDRESS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAddress.deleteEmployeeAddress(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_ADDRESS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_ADDRESS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ADDRESS, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EMPLOYEE_ADDRESS_ISLOADING]: ({ commit }) => {
      commit(SET_EMPLOYEE_ADDRESS, { isLoading: false });
      commit(SET_EMPLOYEE_ADDRESSES, { isLoading: false });
    },
  },
};

export default employeeAddress;
